import { IClassAndFeeStructureSchemaResponse } from '../../../../apis/institute/institute.interfaces';

/**
 * List query runs only after a class is selected and (non-mock) fee structure is loaded,
 * so `classId` / `sectionId` match GET /v1/students.
 */
export function shouldEnableStudentListQuery(params: {
  selectedClassId: string | undefined;
  withMock: boolean;
  classFeesData: IClassAndFeeStructureSchemaResponse | undefined;
}): boolean {
  const { selectedClassId, withMock, classFeesData } = params;
  return (
    !!selectedClassId &&
    (withMock || !!classFeesData?.classes?.length)
  );
}
